import { PROSPECT_TYPE } from "../constants/client";

export const isClientProspect = (type: string | null): boolean =>
  type === PROSPECT_TYPE;
